module.exports = __webpack_public_path__ + "static/media/yahoo-icon.fc39efdb.png";